import { configureStore } from "@reduxjs/toolkit"
import plansReducer from "./redux/features/plansSlice"
import optionsReducer from "./redux/features/optionsSlice"
import companiesReducer from "./redux/features/companiesSlice"
import alertReducer from "./redux/features/alertsSlice";
import subscriptionsReducer from "./redux/features/subscriptionsSlice"
import paymentsReducer from "./redux/features/paymentsSlice"
import supportMembersSlice from "./redux/features/supportMembersSlice"
import promosReducer from "./redux/features/promosSlice"
import customerSupportReducer from  "./redux/features/managersSlice"
import globalReducer from "./redux/features/globalSlice"
import invoicesReducer from "./redux/features/invoicesSlice"

export const store = configureStore({
  reducer: {
    alerts: alertReducer,
    plans: plansReducer,
    options: optionsReducer,
    companies: companiesReducer,
    subscriptions: subscriptionsReducer,
    payments: paymentsReducer,
    supportMembers: supportMembersSlice,
    promos: promosReducer,
    customerSupports: customerSupportReducer,
    global: globalReducer,
    invoices: invoicesReducer
  },
  // devTools: ENVIRONMENT === "development",
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

